/* Masonry layout for the featured style gallery ("Thumbnails layout: Masonry").
   The grid uses grid-auto-rows: 1px (see section-product-style-gallery.css);
   this script spans each item across enough rows for its natural height plus
   --masonry-vertical-gap, so items pack into the shortest column. It then
   places one .aso-masonry-filler per column so every column ends on the same
   bottom line: the lowest column gets an exact 1:1 square and the others
   stretch to match (so no filler is ever shorter than it is wide). */
(function () {
  var ROW_UNIT = 1;
  var observedGrids = new WeakSet();

  function verticalGap(grid) {
    var value = parseFloat(getComputedStyle(grid).getPropertyValue('--masonry-vertical-gap'));
    return isNaN(value) ? 4 : value;
  }

  function itemContent(item) {
    return item.querySelector('.modal-opener-link') || item.firstElementChild;
  }

  function isFiller(item) {
    return item.classList.contains('aso-masonry-filler');
  }

  function realItems(grid) {
    return Array.prototype.filter.call(grid.children, function (item) {
      return !isFiller(item);
    });
  }

  function fillerItems(grid) {
    return Array.prototype.filter.call(grid.children, isFiller);
  }

  function spanItems(grid) {
    var gap = verticalGap(grid);
    realItems(grid).forEach(function (item) {
      var content = itemContent(item);
      if (!content) return;
      var height = content.getBoundingClientRect().height;
      item.style.gridRowEnd = 'span ' + Math.max(1, Math.ceil((height + gap) / ROW_UNIT));
    });
  }

  /* "One spanning image" filler style: cache the image per URL so we can read its
     natural size; re-lay-out the span grids once it loads (fallback color until then). */
  var spanImages = {};
  function spanImage(url) {
    var entry = spanImages[url];
    if (!entry) {
      entry = { img: new Image(), loaded: false };
      entry.img.onload = function () {
        entry.loaded = true;
        document.querySelectorAll('ul.aso-masonry[data-filler-span]').forEach(layoutGrid);
      };
      entry.img.src = url;
      spanImages[url] = entry;
    }
    return entry.loaded ? entry.img : null;
  }

  function placeFillers(grid) {
    var fillers = fillerItems(grid);
    if (!fillers.length) return;

    /* Hide first so stale filler placements can't affect the measurements below */
    fillers.forEach(function (filler) {
      filler.style.display = 'none';
    });

    var items = realItems(grid);
    if (!items.length) return;

    var style = getComputedStyle(grid);
    var columnCount = style.gridTemplateColumns.split(' ').length;
    var columnGap = parseFloat(style.columnGap) || 0;
    var gridLeft = grid.getBoundingClientRect().left;
    var columnWidth = items[0].getBoundingClientRect().width;

    /* Column heights in rows (= px): sum of the spans set in spanItems, which
       already include the vertical gap, so each filler starts one gap below
       the item above it. Items are mapped to columns by their x offset. */
    var columnHeights = [];
    for (var c = 0; c < columnCount; c++) columnHeights.push(0);
    items.forEach(function (item) {
      var left = item.getBoundingClientRect().left - gridLeft;
      var column = Math.min(columnCount - 1, Math.max(0, Math.round(left / (columnWidth + columnGap))));
      var span = parseInt((item.style.gridRowEnd || '').replace('span', ''), 10);
      if (!isNaN(span)) columnHeights[column] += span;
    });

    /* Bottom line = lowest column + a 1:1 square */
    var bottomRow = Math.max.apply(null, columnHeights) + Math.round(columnWidth);

    /* Span style: one image cover-cropped over the filler region (highest filler top
       -> bottom line, full grid width); each block's background shows its slice. */
    var spanUrl = grid.getAttribute('data-filler-span');
    var img = spanUrl ? spanImage(spanUrl) : null;
    var regionTop = Math.min.apply(null, columnHeights.slice(0, columnCount));
    var regionWidth = grid.getBoundingClientRect().width;
    var regionHeight = bottomRow - regionTop;
    var scaledWidth = 0;
    var scaledHeight = 0;
    if (img) {
      var scale = Math.max(regionWidth / img.naturalWidth, regionHeight / img.naturalHeight);
      scaledWidth = img.naturalWidth * scale;
      scaledHeight = img.naturalHeight * scale;
    }

    fillers.forEach(function (filler, index) {
      if (index >= columnCount) return; /* stays hidden */
      filler.style.gridColumn = String(index + 1);
      filler.style.gridRow = (columnHeights[index] + 1) + ' / ' + (bottomRow + 1);
      if (img) {
        var offsetX = index * (columnWidth + columnGap) + (scaledWidth - regionWidth) / 2;
        var offsetY = columnHeights[index] - regionTop + (scaledHeight - regionHeight) / 2;
        filler.style.backgroundImage = 'url("' + spanUrl + '")';
        filler.style.backgroundRepeat = 'no-repeat';
        filler.style.backgroundSize = scaledWidth + 'px ' + scaledHeight + 'px';
        filler.style.backgroundPosition = -offsetX + 'px ' + -offsetY + 'px';
      } else {
        /* images / color styles (or span image still loading): fallback to CSS */
        filler.style.backgroundImage = '';
        filler.style.backgroundRepeat = '';
        filler.style.backgroundSize = '';
        filler.style.backgroundPosition = '';
      }
      filler.style.display = 'block';
    });
  }

  function layoutGrid(grid) {
    spanItems(grid);
    placeFillers(grid);
  }

  function initGrid(grid) {
    layoutGrid(grid);
    if (observedGrids.has(grid)) return;
    observedGrids.add(grid);
    var resizeObserver = new ResizeObserver(function () {
      layoutGrid(grid);
    });
    realItems(grid).forEach(function (item) {
      var content = itemContent(item);
      if (content) resizeObserver.observe(content);
    });
    resizeObserver.observe(grid);
  }

  function initAll(root) {
    (root || document).querySelectorAll('ul.aso-masonry').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* The theme editor re-renders the section on every setting/block change */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
